import { useState } from "react";
import { ChevronLeft, ChevronRight, CheckIcon } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";

import Image from "../ui/Image";
import book from "../../assets/used-icons/book.png";
import IvoryGold from "../../assets/icons/IvoryGold.svg";

import logo from "../../assets/used-images/cmi-logo.png";
import DeliveryMechanism1 from "../../assets/used-images/learning-solutions-1.png";
import DeliveryMechanism2 from "../../assets/used-images/learning-solutions-2.png";
import DeliveryMechanism3 from "../../assets/used-images/learning-solutions-3.png";
import DeliveryMechanism4 from "../../assets/used-images/learning-solutions-4.png";
import DeliveryMechanism5 from "../../assets/used-images/learning-solutions-5.png";
import DeliveryMechanism6 from "../../assets/used-images/learning-solutions-6.png";
import DeliveryMechanism7 from "../../assets/used-images/learning-solutions-7.png";
import DeliveryMechanism8 from "../../assets/used-images/learning-solutions-8.png";

import ServiceApplyBtn from "../ui/ServiceApplyBtn";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import axios from "axios";
import getToken from "../../hooks/getToken";
import ServiceRegisterNoAuth from "../ui/service-no-auth";
import Swal from "sweetalert2";
import Breadcrumb from "../Pages/Breadcrumb";
import CMILogo from "./logopart";
import CMIDesign from "./cmidesign";
import Plan from "./CardLayout-1";
import LearningOutcomes from "./learning";
import CmiCourses from "./cmi-courses";

const CMi = () => {
    const URL = process.env.REACT_APP_IVORY_API;
    const token = getToken();
    const [noAuthSeen, setNoAuthSeen] = useState(false);
    const [packageName, setPackageName] = useState('');
    const [isLoadingPackage, setIsLoadingPackage] = useState({
        isLoading: false,
        loadingPackageName: ''
    })

    const [activeTab, setActiveTab] = useState("strong");
    const [activeService, setActiveService] = useState(1);
    const [activeMicro, setActiveMicro] = useState(1);
    const [seeFeatures, setSeeFeatures] = useState(null);

    const points = {
        strong: [
            {
                title: 'الخبرة المتخصصة',
                content: 'غالبًا ما يتمتع مقدمو خدمات التعلم والتطوير بمجموعة واسعة من الخبرات والتجارب عبر مختلف الصناعات والقطاعات. وهم على دراية بأحدث منهجيات وتقنيات واتجاهات التدريب، مما يضمن استفادة مؤسستك من قاعدة معرفية متنوعة وواسعة.',
            },
            {
                title: 'فعالية التكلفة',
                content: 'غالبًا ما يكون الاستعانة بمصادر خارجية أكثر فعالية من حيث التكلفة. فهو يلغي الحاجة إلى الرواتب والمزايا والتكاليف العامة الأخرى المرتبطة بفريق داخلي بدوام كامل. أنت تدفع مقابل ما تحتاجه، عندما تحتاج إليه.',
            },
            {
                title: 'اتساع نطاق الخدمة',
                content: 'يمكن لمقدم الخدمة الخارجي بسهولة توسيع نطاق برامج التدريب لأعلى أو الأسفل بناءً على احتياجات المؤسسة، مما يجعله حلاً أكثر مرونة.',
            },
            {
                title: 'تركيز الجهد',
                content: 'من خلال الاستعانة بمصادر خارجية في مجال التعلم والتطوير، يمكن للمؤسسات التركيز بشكل أكبر على وظائف أعمالها الأساسية. وهذا يسمح بتخصيص الموارد بشكل أفضل وتحسين أداء الأعمال.',
            },
            {
                title: 'التحديث المستمر',
                content: 'يتمتع مقدمو خدمات التعلم والتطوير بالقدرة على التكيف مع التغيرات السريعة في التقنيات والمعرفة، مما يضمن الحفاظ على مهارات الموظفين حديثة ومناسبة.',
            },
            {
                title: 'تنوع الخبرات',
                content: 'مقدمو الخدمات الخارجية يمتلكون خبرات في العديد من الصناعات والمناطق الجغرافية، مما يمكنهم من تقديم منظورات متنوعة ونقاط نظر عالمية.',
            },
        ],
        weak: [
            {
                title: 'ارتفاع التكاليف',
                content: 'قد يكون الحفاظ على قسم التعلم والتطوير داخل الشركة أمرًا مكلفًا. يتضمن تكاليف الرواتب والمزايا والمواد التدريبية والموارد والتطوير المهني المستمر لفريق التعلم والتطوير.',
            },
            {
                title: 'ضيق زاوية النظر',
                content: 'قد يفتقر الفريق الداخلي إلى المنظور الصناعي الواسع الذي يأتي من العمل مع مؤسسات متعددة. ومن المحتمل أن يحد هذا من الابتكار في أساليب التدريب ومحتواه.',
            },
            {
                title: 'محدودية الموارد',
                content: 'قد يعاني الفريق الداخلي من عدم وجود الموارد المتخصصة التي يمكن أن توفرها شركات التدريب الخارجية، مثل التكنولوجيا المتطورة، أو الخبرات الصناعية العميقة.',
            },
            {
                title: 'صعوبة المتابعة',
                content: 'قد يجد الفريق الداخلي صعوبة في مواكبة أحدث الاتجاهات والممارسات في مجال التعلم والتطوير، خاصة في بيئة العمل السريعة اليوم.',
            },
        ]
    };
    const services = {
        1: [
            {
                title: ' اتخاذ قرارات استراتيجية',
                image: logo,
                description: 'يمكن للقادة المجهزين بمهارات اتخاذ القرارات المستندة إلى البيانات الاستفادة من التحليلات المتقدمة لتوجيه المبادرات الاستراتيجية، مما يؤدي إلى تحسين تخصيص الموارد ودفع النمو المستدام.'
            },
            {
                title: ' تجربة عملاء فائقة',
                image: logo,
                description: 'يضمن التدريب على إدارة تجربة العملاء تقديم المنظمة لخدمة استثنائية باستمرار، مما يعزز ولاء العملاء وسمعة العلامة التجارية، ويؤثر مباشرة على نمو الإيرادات.'
            },
            {
                title: '  تنفيذ التغيير بسلاسة',
                image: logo,
                description: 'يمكن لمديري التغيير المهرة قيادة التحولات التنظيمية بأقل قدر من الاضطراب، مما يضمن تنفيذ مبادرات التغيير بفعالية، مما يؤدي إلى تحسين الكفاءة التشغيلية والموقع التنافسي.'

            }
            , {
                title: ' ثقافة الابتكار',
                image: logo,
                description: 'تشجيع ثقافة تقدر الابتكار يمكّن المنظمة من تطوير منتجات وخدمات متطورة باستمرار، مما يحافظ على ميزة تنافسية في سوق سريع التطور'
            },
            {
                title: '  إدارة مالية قوية ',
                image: logo,
                description: 'يؤدي تعزيز الفطنة المالية بين المديرين إلى وضع ميزانيات دقيقة، وتنبؤات دقيقة، وتخطيط مالي استراتيجي، مما يؤدي إلى تحسين الصحة والاستقرار المالي.'
            },
            {
                title: ' تعزيز تفاعل الأطراف المعنية',
                image: logo,
                description: 'يؤدي إدارة علاقات الأطراف المعنية بفعالية إلى تعزيز الشراكات والتعاون، مما يضمن التوافق مع الأهداف الاستراتيجية وتعزيز بيئة الأعمال الداعمة.'
            },
            {
                title: '  بيئة متنوعة وشاملة ',
                image: logo,
                description: 'تعزيز المساواة والتنوع والشمول يزرع ثقافة تنظيمية إيجابية، مما يجذب أفضل المواهب، ويعزز مشاركة الموظفين، ويقلل من معدلات الدوران.'
            },
            {
                title: '  تطوير القيادة والتدريب ',
                image: logo,
                description: 'تطوير قدرات التدريب والإرشاد داخل فريق القيادة يعزز تطوير المواهب، ويدفع أداء الموظفين، ويعزز ثقافة التحسين المستمر'
            },

        ],
        2: [
            {
                title: ' تعزيز الممارسة التأملية  ',
                image: logo,
                description: 'تطوير مهارات الممارسة التأملية يسمح للمشاركين بتحليل أدائهم بشكل نقدي، وتحديد مجالات التحسين، وتنفيذ خطط التنمية الشخصية، مما يؤدي إلى النمو المهني المستمر.'
            },
            {
                title: '    قدرات تحليلية متقدمة  ',
                image: logo,
                description: 'يمكن للتدريب في تحليل البيانات وتفسيرها تمكين المشاركين من اتخاذ قرارات مستنيرة، مما يعزز قدرتهم على المساهمة في استراتيجية الأداء التنظيمي.'
            },
            {
                title: '    قيادة تركز على العميل',
                image: logo,
                description: 'فهم وتنفيذ استراتيجيات تجربة العملاء يجهز المشاركين لدفع رضا العملاء وولائهم، مما يجعلهم عوامل رئيسية في نجاح الأعمال.'
            },
            {
                title: '   مهارة إدارة التغيير ',
                image: logo,
                description: 'اكتساب الخبرة في إدارة التغيير يمكّن المشاركين من قيادة مبادرات التغيير بنجاح، وتقليل المقاومة وزيادة القبول، مما يعزز مرونة المنظمة.'
            },
            {
                title: '  إتقان التدريب والإرشاد  ',
                image: logo,
                description: 'تطوير مهارات التدريب والإرشاد يعزز قدرة المشاركين على تطوير المواهب، وتحسين أداء الفريق، وزراعة ثقافة تنظيمية داعمة.'
            },
            {
                title: '    التفكير الابتكاري',
                image: logo,
                description: 'التدريب في إدارة الابتكار يعزز حل المشكلات الإبداعية والتفكير الاستراتيجي، مما يمكّن المشاركين من المساهمة في تطوير حلول مبتكرة تدفع نمو الأعمال.'
            },
            {
                title: '   الفطنة المالية',
                image: logo,
                description: 'الفهم المحسن لمبادئ الإدارة المالية يجهز المشاركين بالمهارات اللازمة لإدارة الميزانيات بفعالية، وتحسين الموارد المالية، والمساهمة في الاستراتيجية المالية للمنظمة.'
            },
            {
                title: '   خبرة إدارة المشاريع',
                image: logo,
                description: 'تنفيذ المشاريع الإدارية يصقل مهارات البحث والتخطيط والتنفيذ لدى المشاركين، مما يمكّنهم من إدارة المبادرات المعقدة ودفع نتائج المشاريع الناجحة.'
            },

        ],

    };
    const steps = [
        ' اليوميات التأملية للتطوير المستمر ',
        '   تقارير تحليل البيانات لاتخاذ القرارات',
        '  مشاريع رسم خريطة رحلة العميل لتحسين تجربة العملاء',
        'خطط إدارة التغيير لتنفيذ التغيير ',
        '  خطط برامج التدريب والإرشاد',
        ' خطط إدارة الأطراف المعنية  ',
        'خطط إدارة الابتكار',
        '   خطط إدارة المالية',
        'تقارير وخطط المشاريع البحثية',
        'خطط وسياسات التنفيذ للمساواة والتنوع والشمول (EDI)',
    ];
    const deliveryMechanisms = [
        {
            img: DeliveryMechanism1,
            title: "بناء أدوات التقييم",
            desc: "نعمل على بناء أدوات التقييم لتحديد مدى تحقيق الأهداف التعليمية، وظفوم بتحديد البيانات المستلمة للتقديم تقارير فعالة وتوصيات مستندة على البيانات."
        },
        {
            img: DeliveryMechanism2,
            title: "الإرشاد والدعم للمستفيدين",
            desc: "تقدم الدعم والإرشاد اللازم للمشاركين طوال البرنامج: تتضمن مناسبات الزوجية الفردية واستخدام أدوات التواصل الأساسي."
        },
        {
            img: DeliveryMechanism3,
            title: "تقديم الإرشاد العملي",
            desc: "تقدم النصائح المعنية للموظفين حول التطور العملي، وتساعدهم في تحديد أهدافهم ووضوح خطط التطوير."
        },
        {
            img: DeliveryMechanism4,
            title: "تفعيل برامج التعلم المستمر",
            desc: "نعمل على إنشاء وتنفيذ برامج التعلم المستمر لتشجيع الموظفين على تحسين معارفهم ومهاراتهم بعد البرامج التدريبية الأولية."
        },
        {
            img: DeliveryMechanism5,
            title: "تطوير الدورات المستهدفة",
            desc: "نعمل على بناء أدوات التقييم لتحديد مدى تحقيق الأهداف التعليمية، وظفوم بتحديد البيانات المستلمة للتقديم تقارير فعالة وتوصيات مستندة على البيانات."
        },
        {
            img: DeliveryMechanism6,
            title: "التنسيق الفعال للبرامج التعليمية",
            desc: "تقوم بتحرير البرامج التعليمية من خلال مستشارينا وذلك لضمان الالتزام بالمعايير والأهداف المحددة."
        },
        {
            img: DeliveryMechanism7,
            title: "تنفيذ العقد",
            desc: "نعد ونقدم مدى التعليم والتطوير الدكتوري أو البلاغولي، ونوجه المستفيدين خلال الجلسات التدريبية المباشرة أو عبر المنصات."
        },
        {
            img: DeliveryMechanism8,
            title: "بناء القدرات",
            desc: "تطوير برامج التنمية الشخصية لموظفينا، تقدم ملاحظات تعزيز من تطوير العمليات، وتنظم فعاليات تفاعلية لتعزيز التقدم العملي."
        }
    ];
    const microsLearning = {
        1: [
            {
                title: "توفير الوقت والموارد",
                description: "يقلل من الوقت والمجهود المطلوبة لتدريب العاملين مما يقلل من الأعباء المالية ويزيد من الكفاءة"
            },
            {
                title: "تحسين الاحتفاظ بالمعلومات",
                description: "تقديم المعلومات بشكل مصور ومتفاعل مما يساعد على تحسين الاحتفاظ بالمعلومات وتطبيقها"
            },
            {
                title: "تعزيز الإنتاجية",
                description: "يسمح للمستخدمين بتطوير مهاراتهم ومعرفتهم دون التأثير السلبي على إنتاجيتهم اليومية"
            },
            {
                title: "تعزيز الانخراط والرضا عن العمل",
                description: "يساهم في رفع مستوى الرضا عن العمل والانخراط بين الموظفين وذلك من خلال توفير فرص التطور والتحفيز المستمر"
            },
            {
                title: "تدريب مستمر",
                description: "إتاحة فعالة للتدريب المستمر والتطوير المهني حيث يمكن تحديث وتوسيع المحتوى بسهولة"
            },
            {
                title: "تحسين نتائج العمل",
                description: "تعزيز الاحتفاظ بالمعلومات وتطبيق الأفكار الجديدة في العمل، يمكن أن يؤدي التعلم الجديد إلى تحسين الأداء لمهام مختلفة"
            }
        ],
        2: [
            {
                title: "تعزيز التركيز",
                description: "يساعد في تحسين التركيز بفضل الدروس القصيرة التي تمتد لبضع دقائق فقط"
            },
            {
                title: "راحة العقل",
                description: "بفضل الوحدات القصيرة يمكن التعلم في الأوقات التي يشعرون فيها بأنهم أكثر استعداد اوتركيزا مما يقلل من الضغط والتوتر"
            },
            {
                title: "تحسين الاحتفاظ بالمعلومات",
                description: "يؤدي تقديم المعلومات في أجزاء صغيرة ومنظمة إلى تحسين الاحتفاظ بالمعلومات والقدرة على تطبيقها بشكل فعال"
            },
            {
                title: "التعلم بالسرعة المناسبة",
                description: "يمكن المستفيد من التقدم في المحتوى حسب وتيرته الخاصة وعندما يكونوا جاهزين له"
            },
            {
                title: "المرونة",
                description: "التعلم الدقيق يتيح الوصول إلى المحتوى من أي مكان وفي أي وقت مما يجعله مرنا ومناسبا"
            },
            {
                title: "تحسين الأداء الوظيفي",
                description: "توفر الوحدات القصيرة والمحددة فرصة أكبر للتذكر والتطبيق العملي مما يؤدي إلى تحسين الأداء الوظيفي"
            }
        ]
    };
    const developments = [
        {
            title: 'التحليل',
            description: 'تبدأ الرحلة بفحص دقيق للكفاءات الحالية للمتعلم. باستخدام مجموعة من الأدوات، من الاختبارات التشخيصية إلى الملاحظات المباشرة، نحدد بوضوح قواطع القوة والنقاط التي تحتاح الى تحسين',
        },
        {
            title: 'الاستراتيجية',
            description: 'مع الفهم الواضح الذي تم الحصول عليه من مرحلة التقييم، نبني استراتيجية تعلم مخصصة. نحدد الأهداف الدقيقة والقابلة للتحقيق ونطور خطة شاملة لتحقيق هذه الأصراف',
        },
        {
            title: 'التدريب',
            description: 'بعد وضع الخطة الاستراتيجية يتم بدء مرحلة التدريب من خــ لال ورش عمل تفاعلية ومركزة',
        },
        {
            title: 'القياس',
            description: 'إجراء تقييم شامل باستخدام أدوات متنوعة مثل تقييمات الأداء والتقييمات الذاتية والتقييمات الزميلية وجلسات التغذية الراجعة',
        },
        {
            title: 'التقدم',
            description: 'نلتزم بتعزيز التعلم والتطور المستمر. نقوم بتقييمات دورية للتقدم ونعدل مسار التعلم بشكل ديناميكي استنادا إلى هذه التقييمات',
        },
        {
            title: 'الفحص',
            description: 'الفحوصات الدورية لأداء المتعلم تساعدنا في الكشف عن أي فجوات مهارية قد تكون ما زالت موجودة',
        },
        {
            title: 'الترسيخ',
            description: 'نوفر فرصا متعددة للممارسة والتطبيق العملي لترسيخ المهارات التي تم اكتسابها',
        },
    ];
    const servicePackages = [
        {
            title: "حزمة أساس",
            description: "تضع قواعد رحلة التعلم في المنظمة. حيث تقوم ببناء مسارات تعلمية مخصصة تتوافق مع أهداف المنظمة، وتقدم مجموعة غنية من الموارد التعلمية المتعلقة، وتضمن دعما شاملاً يسهل التنقل والاستخدام الفعال لمنصة التعلم.",
            features: [
                "مسارات التعلم المخصصة التي تتوافق مع أهداف المنظمة",
                "توفير مجموعة غنية من الموارد التعليمية المتعلقة",
                "دعم شامل يضمن النقل والاستخدام السهل لمنصة التعلم",
            ],
        },
        {
            title: "حزمة رسوخ",
            description: "تهدف الى تنشيط العناصر الاساسية المقامة فى حزمة “ اساس “ عن طريق تطوير انشطة تفاعلية وبرامج تقدير لتحفيز المشاركة المستمرة للمتعلمين, وتقدم وسيلة لرصد وتتبع تقدم المتعلمين",
            features: [
                "مسارات التعلم المخصصة التي تتوافق مع أهداف المنظمة",
                "توفير مجموعة غنية من الموارد التعليمية المتعلقة",
                "دعم شامل يضمن النقل والاستخدام السهل لمنصة التعلم",
                "تطوير أنشطة تفاعلية وبرامج تقدير لتحفيز المشاركة المستمرة للمتعلمين",
                "تقديم وسيلة لرصد وتتبع تقدم المتعلمين",
            ],
        },
        {
            title: "حزمة تفوق",
            description: 'تبني على حزمة "" رسوخ "" لتقدم تجربة تعلم ديناميكية ومتطورة باستمرار. تلتزم بتحديث محتوى التعلم بانتظام بما يتوافق مع أحدث التطورات في الصناعة، وتقدم تقييمات مفصلة لتقدم المتعلمين، وتدخل عنصر التخصيص في رحلة التعلم.',
            features: [
                "تطوير أنشطة تفاعلية وبرامج تقدير لتحفيز المشاركة المستمرة للمتعلمين",
                "تقديم وسيلة لرصد وتتبع تقدم المتعلمين",
                "التزام بتحديث محتوى التعلم بالنظام بما يتوافق مع أحدث التطورات في الصناعة",
                "تقديم تقييمات مفصلة لتقدم المتعلمين",
                "دخول عنصر التخصيص في رحلة التعلم",
            ],
        },
        {
            title: "حزمة تخصيص",
            description: 'مصممة لتوفير المرونة لعملائنا. حيث توفر للمنظمات القدرة على إنشاء حلول تعلم مخصصة لهم وفريدة بهم. يمكن للعملاء اختيار ودمج أي من مكونات الحزم الأخرى. مما يتيح لهم خلط ومطابقة الخدمات الإنشاء برنامج يناسب احتياجاتهم الفريدة في التعلم والتطوير',
            features: [
                "إنشاء حلول و موارد تعلم مخصصة",
                "دمج أي من خدمات حزم الخدمات الأخرى ضمن هذه الحزمة",
            ],
        },
    ];

    const subscribeInService = async (packageTitle) => {
        if (token) {
            setIsLoadingPackage({ isLoading: true, loadingPackageName: packageTitle })
            try {
                const response = await axios.post(`${URL}/ar/packages`, {
                    package_name: packageTitle,
                    service_id: 6,
                }, { headers: { "Authorization": `Bearer ${token}` } });
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'تم التسجيل بنجاح',
                        text: `تم الاشتراك في  ${packageTitle} بنجاح`,
                        confirmButtonText: 'موافق'
                    })
                }
            } catch (error) {
                if (error.status === 400) {
                    Swal.fire({
                        icon: 'info',
                        title: 'تم التسجيل من قبل ',
                        text: `عفوا انت بالفعل مشترك في حزمة مسبقا`,
                        confirmButtonText: 'موافق'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'فشل الطلب',
                        text: 'حدث خطأ ما , برجاء المحاولة لاحقا',
                        confirmButtonText: 'حاول مرة أخرى'
                    })
                }
            } finally {
                setIsLoadingPackage({ isLoading: false, loadingPackageName: '' });
            }
        } else {
            setNoAuthSeen(true);
            setPackageName(packageTitle)
        };
    };

    return (
        <>
            <Breadcrumb pages={["المنتجات", " برنامج المدير المعتمد "]} />

            {/* قسم التعلم و التطوير الداخلي */}
            <main className="container " style={{ margin: "40px auto" }}>
                <section className="grid grid-cols-[29%_69%] max-md:grid-cols-1 gap-4">
                    <div className="w-full h-72 rounded-xl relative">
                        <Image
                            src='https://ivorytraining.com/cmi/assets/img/chartered-manager.png'
                            alt={'learing solutions'}
                            className={'w-full h-full object-cover object-top rounded-xl'}
                        />
                    </div>
                    <div className="border rounded-lg p-3">
                        <h2 className="services-header after:w-20 after:-bottom-2">
                            برنامج المدير المعتمد (Certified Manager)
                        </h2>
                        <article className="text-semi-gray !text-start mt-4">
                            في عالمٍ يتطلب كفاءات قيادية استثنائية، يضعك برنامج المدير المعتمد (CMgr) في مقدمة المنافسة. على مدار 194 ساعة تدريبية مكثفة تشمل 10 دورات متخصصة، ستحصل على الأدوات والمهارات التي تؤهلك للريادة في أدوارك القيادية الحالية والمستقبلية. عند اجتياز البرنامج، تنضم إلى النخبة بحصولك على لقب مدير معتمد (CMgr) المرموق من معهد الإدارة المعتمد (CMI). هذا اللقب العالمي لا يقتصر على تعزيز سيرتك المهنية فقط، بل يُظهر التزامك بمعايير الإدارة والقيادة الأعلى، وقدرتك على قيادة الفرق، تحقيق النتائج، وتعزيز النجاح المؤسسي. كن جزء من شبكة عالمية حصرية من القادة المعتمدين، واستفد من فرص مهنية غير محدودة ودعم مستمر لتحسين أدائك وتحقيق طموحاتك القيادية.
                        </article>
                    </div>
                </section>
                <CMILogo />
                <CMIDesign />
                <Plan />
            </main>


            {/* الخدمات */}
            <main className="container" style={{ margin: '40px auto' }}>
                <div className="flex justify-content-center">
                    <p className="services-header after:-bottom-2 after:w-20 flex justify-center">الفوائد</p>
                </div>
                <div className="flex flex-wrap  justify-content-center items-center gap-3 mt-4 mb-4">
                    <button className={`border py-2 px-4 rounded-lg ${activeService === 1 ? 'bg-primary-tw text-white' : 'text-semi-gray'}`}
                        onClick={() => setActiveService(1)}>
                        الفوائد للمنظمة                    </button>
                    <button className={`border py-2 px-4 rounded-lg ${activeService === 2 ? 'bg-primary-tw text-white' : 'text-semi-gray'}`}
                        onClick={() => setActiveService(2)}>
                        الفوائد للمشارك                     </button>

                </div>

                <div className="grid grid-cols-2 gap-8 py-6 px-2 max-xl:grid-cols-2 max-lg:grid-cols-1">
                    {
                        services[activeService].map((service, i) => (
                            <div key={i} className="text-center relative  border rounded-lg p-3 bg-white shadow-sm flex-column align-items-center">

                                <div className="flex justify-center position-relative -top-10">
                                    <img src={IvoryGold} alt="التدريب المتخصص" className="" />
                                </div>
                                <p className="text-lg bottom-3 font-semibold text-[#414042] mb-2">
                                    التدريب المتخصص
                                </p>
                                <p className="text-sm text-dark-gray">
                                    برامج تدريبية متخصصة لتطوير المهارات
                                </p>
                            </div>
                        ))
                    }
                </div>
            </main>

            <CmiCourses />
            <main className="bg-[#f5f5f5] py-4 px-20 max-lg:px-4">
                <div className="flex justify-center">
                    <p className="services-header after:-bottom-2 after:w-20 flex justify-center">
                        طرق التقييم
                    </p>
                </div>
                <article className="text-semi-gray text-center">
                    بناء على المقارنة , يمكن ان يكون الاستعانة بمصادر خارجية فى مجال التعلم والتطوير خياراً افضل للعديد من المؤسسات,<br className="max-md:hidden" /> نظراً لفوائده من حيث الخبرة وفعالية التكلفة وقابلية التوسع والسماح للمؤسسات بالتركيز على اعمالها الاساسية.
                </article>
                <div className="grid grid-cols-5 gap-8 py-6 px-2 max-2xl:grid-cols-3 max-xl:grid-cols-2 max-lg:grid-cols-1">
                    {
                        steps.map((step, i) => (
                            <div key={i} className="border px-2 py-2 rounded-lg text-center relative z-0 bg-white flex-column align-items-center flex">
                                <div className="size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw mb-2 bg-white ">
                                    <p className="text-lg font-bold bg-secondary-tw text-white rounded-full w-10 h-10  flex justify-center items-center m-auto">
                                        <img src={book} alt="" />
                                    </p>
                                </div>
                                <p className="text-lg text-gray fs-6">
                                    {step}
                                </p>
                            </div>
                        ))
                    }
                </div>
            </main>

            <div className="mt-5 mb-3">
                <ServiceApplyBtn serviceId={9} serviceName={'المدير المعتمد'} />
            </div>

        </>
    );
};

export default CMi;